class WIvideoPaly extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.videoInterSection();
    }
    // Video play
    videoPlay() {
        let playBtn = this.querySelector('.WI_videoPlayIcon');
        let videoUrl = this.querySelector('video').getAttribute('data-videoUrl');
        let videoSource = this.querySelector('.WI_videoSource');
        videoSource.src = videoUrl+"#t=0.1";
        this.querySelector('video').load();
        playBtn.addEventListener('click', ()=>{
            this.querySelector('video').play();
            playBtn.style.display = "none";
        });
    }
    // Video intersection
    videoInterSection() {
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.videoPlay();
                }
            });
        },{threshold: 0, rootMargin: "0px 0px 0px 0px"});
        observer.observe(this);
    }
}

customElements.define('wi-videoplay', WIvideoPaly);